import { Injectable, effect } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';

import { LanguageChangeService } from './language-change.service';

@Injectable()
export class CustomMessagesService extends MessageService {
  constructor(private langService: LanguageChangeService) {
    super();

    effect(() => {
      this.langService.languageChangedSignal();
      this.notify();
    });
  }

  public override get(key: string): string {
    const map = {
      'kendo.pager.itemsPerPage': 'pager_itemsPerPage',
      'kendo.pager.items': 'pager_items',
    };

    const translationKey = map[key];
    if (translationKey) {
      return this.langService.translate(translationKey);
    }

    return super.get(key);
  }
}
